module.exports = __webpack_public_path__ + "media/images/HPB-15b19404.png";